import React from 'react';
import { useTranslation } from 'react-i18next';

import css from './OrdersSingleOrderComponent.module.css';
import {formatDateWithoutLocalDate, getNormalizeDate} from "../../../helpers";


const OrdersSingleOrderComponent = ({obj, setIsOpenModalInfo, setSelectedOrderId}) => {
    const { t } = useTranslation();
    
    if (!obj) return null;

    const {
        id,
        client,
        debt,
        paid,
        pack,
        paymentAmount,
        paymentMethod,
        paymentStatus,
        creationDate,
        unpaid,
        isFirstOrder
    } = obj;

    const contact = client?.phoneNumber;

    const formatted = getNormalizeDate(creationDate);

    const handleClickOrderInfo = () => {
        setIsOpenModalInfo(true);
        setSelectedOrderId(id);
    }

    // Only show payment amounts if status is Created or Completed
    const shouldShowPaymentAmounts = paymentStatus === 'Created' || paymentStatus === 'Completed';
    
    // Determine payment status class based on status value
    const getPaymentStatusClass = () => {
        switch(paymentStatus) {
            case 'Completed':
                return css.statusCompleted;
            case 'Created':
                return css.statusCreated;
            case 'Rejected':
            case 'Declined':
                return css.statusRejected;
            case 'Other':
            default:
                return css.statusOther;
        }
    };

    // Get translated payment status text
    const getPaymentStatusText = () => {
        switch(paymentStatus) {
            case 'Completed':
                return t('completed');
            case 'Created':
                return t('created');
            case 'Rejected':
                return t('rejected');
            case 'Declined':
                return t('declined');
            case 'Other':
                return t('other');
            default:
                return paymentStatus;
        }
    };

    return (
        <div className={css.wrap} onClick={handleClickOrderInfo}>
            <div className={css.order}>{id}</div>
            <div className={css.contact}>{contact}</div>
            <div className={css.name}>
                {client?.clientName || '-'}
                {isFirstOrder && <span className={css.firstOrderTag}>{t('first-order')}</span>}
            </div>
            <div className={css.dietType}>{pack.name['en']}</div>
            <div className={css.createdAt}>{formatted}</div>
            <div className={css.paid}>{shouldShowPaymentAmounts && paid > 0 ? paid : '-'}</div>
            <div className={css.unpaid}>{shouldShowPaymentAmounts && unpaid > 0 ? unpaid : '-'}</div>
            <div className={css.debit}>{shouldShowPaymentAmounts && debt > 0 ? debt : '-'}</div>
            <div className={css.paymentStatus}>
                <span className={getPaymentStatusClass()}>{getPaymentStatusText()}</span>
            </div>
            <div className={css.paymentMethod}>{paymentMethod}</div>
        </div>
    );
};

export default React.memo(OrdersSingleOrderComponent);